import "./fieldGuide/fieldGuide.scss";
import { createApp } from "vue/dist/vue.esm-bundler.js";
import Combobox from "components/combobox/Combobox.vue";

const container = document.getElementById("js-fieldGuideSearchForm");

const app = createApp({
  delimiters: ["${", "}"],
  components: {
    Combobox,
  },
  data() {
    return {
      searchQuery: "",
      fgType: "",
      fgHabitat: "",
    };
  },
  methods: {
    handleSubmit: function () {
      const form = this.$refs.form;
      const action = new URL(form.getAttribute("action"));
      const data = new FormData(form);
      const params = new URLSearchParams(data);
      params.forEach((value, key) => {
        if (value !== "") {
          action.searchParams.set(key, value);
        }
      });
      window.location.href = action.toString();
    },
  },
});
app.mount(container);
